module.exports = __webpack_public_path__ + "media/scholarship_winners/natalie-sw-49975d33.png";